// Base URL for self-test QR payloads; in local dev use your PC LAN IP (phones cannot reach localhost on your machine).
export function getSelfTestQrOrigin(): string {
  let fromEnv = process.env.REACT_APP_QR_ORIGIN?.trim();

  if (!fromEnv) {
    const socketUrl = process.env.REACT_APP_API_SOCKET_URL?.trim();
    if (socketUrl) {
      try {
        fromEnv = new URL(socketUrl).origin;
      } catch {
        // Ignore invalid REACT_APP_API_SOCKET_URL.
      }
    }
  }

  if (fromEnv) {
    fromEnv = fromEnv.replace(/\/$/, '');
    if (!/^https?:\/\//i.test(fromEnv)) {
      fromEnv = `http://${fromEnv}`;
    }
    return fromEnv;
  }
  return window.location.origin;
}

type SelfTestQrPayloadOptions = {
  selfTestToken: string;
  roomId: string;
  isIntegration: boolean;
  language: string;
  theme: 'default' | 'dark';
};

// Builds a full self-test URL for the QR (phone camera and in-app scanner need a reachable host).
export function buildSelfTestQrPayload(options: SelfTestQrPayloadOptions): string {
  const mode = options.isIntegration ? 'integration' : 'global';
  const path = `/self_test/${options.selfTestToken}/${options.roomId}/${mode}/${options.language}/${options.theme}`;
  const origin = getSelfTestQrOrigin().replace(/\/$/, '');

  return `${origin}${path}`;
}
